export const UTIL_CONSTS = {
    TOGGLE_LEFT_SIDE_MENU: "TOGGLE_LEFT_SIDE_MENU",
    REDIRECT_FIRST_TIME: "REDIRECT_FIRST_TIME",
    START_LOADING: "START_LOADING",
    END_LOADING: "END_LOADING",
};